import React from 'react';

export default function CurrencyRatesTable({ currencies, onCurrencySelect }) {
	return (
		<div className="table-view table-responsive" id="setting-tables">
			<table id="currency-rates-table" className="table">
				<thead>
					<tr>
						<th>Base Currency</th>
						<th>Foreign Currency</th>
						<th>Default Rate</th>
						<th>Sell Rate</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					{currencies
						? currencies.map(currency => (
								<tr>
									<td>British Pound</td>
									<td>{currency.countryName}</td>
									<td>{currency.buyRate}</td>
									<td>{currency.sellRate}</td>
									<td>
										<i
											data-toggle="modal"
											data-target="#confirmationModal"
											className="fa fa-trash-o icon"
											onClick={() => onCurrencySelect(currency)}
										/>
										<i
											data-toggle="modal"
											data-target="#currencyEditModal"
											className="fa fa-pencil-square-o icon"
											onClick={() => onCurrencySelect(currency)}
										/>
									</td>
								</tr>
						  ))
						: null}
				</tbody>
			</table>
		</div>
	);
}
